import Button from '~/shared/components/Button';
import { Typography } from '~/shared/components';
import { useTranslation } from '~/shared/utils/translation';
import {
    StoreDetails,
    StoreDetailsPanel,
} from '~/features/product-details/components/ReservationDrawer/StoreDetails';
import { StoreAddress } from '~/features/product-details/components/ReservationDrawer/StoreAddress';
import type { ReservationStore } from '~/features/product-details/components/ReservationDrawer/types';
import { getStoreOpeningHoursWithStatus } from '~/features/product-details/components/ReservationDrawer/utils/getStoreOpeningHoursWithStatus';
import styles from '~/features/product-details/components/ReservationDrawer/ReservationStoreList/ReservationStoreList.module.scss';

type Props = {
    store: ReservationStore;
    onBack: () => void;
};

export const ReservationStoreSummary = ({ store, onBack }: Props) => {
    const openingHours = getStoreOpeningHoursWithStatus(store.c_openingHours);
    const { translate } = useTranslation();

    return (
        <div className={styles.storeContentWrapper}>
            <div className={styles.storeContent}>
                <Typography as="h3" variant="paragraph-M" weight="medium">
                    {store.name || ''}
                </Typography>
                <StoreAddress store={store} />
            </div>
            <div className={styles.storeActions}>
                <Button variant="pdp-secondary" onClick={onBack}>
                    {translate('pdp.goBack')}
                </Button>
            </div>
            <StoreDetails>
                <StoreDetailsPanel store={store} openingHours={openingHours} />
            </StoreDetails>
        </div>
    );
};
